import React, { createContext, useReducer, ReactNode } from 'react'

import GlobalMenuOpener, { Action, State } from '../reducers/GlobalMenuOpener'

export const GlobalMenuContext = createContext<{ dispatch: (action: Action) => void; state: State }>({
  dispatch: () => {},
  state: false
})

export function GlobalMenuProvider({ children }: { children?: ReactNode }) {
  const [state, dispatch] = useReducer(GlobalMenuOpener, false)
  return <GlobalMenuContext.Provider value={{ state, dispatch }}>{children}</GlobalMenuContext.Provider>
}
